import { Button } from 'antd';
import { forwardRef } from 'react';
import MyFlex from '../myFlex/MyFlex';
import UtilString from '../../utils/utilString';

const MyButton = forwardRef(
  (
    {
      block,
      style,
      width,
      label,
      loading = false,
      children,
      suffixIcon,
      className = UtilString.EMPTY_STRING,
      ...otherProps
    },
    ref
  ) => {
    const styleLocal = {
      ...style,
      ...(block ? { width: '100%' } : width != null ? { width } : {}),
    };

    return (
      <Button
        {...otherProps}
        ref={ref}
        loading={loading}
        block={block}
        style={styleLocal}
        className={className}
      >
        {label || suffixIcon ? (
          <MyFlex>
            {Boolean(label) && <span className="bold">{label}</span>}
            {Boolean(suffixIcon) && <div>{suffixIcon}</div>}
          </MyFlex>
        ) : (
          children
        )}
      </Button>
    );
  }
);

export default MyButton;
